import {Button} from 'antd'
import {useOpenModal} from '@/components/Modal/index.mjs'
import {ModalDfkAdd} from '@/pages/MainPage/frames/DfList/DfkAdd.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'

export default function PropertiesPaneButtonMakeFk(props) {
    const openModal = useOpenModal()
    const map = useMapContext()
    const permission = map.usePermission()
    const selectedNodes = map.useSelectedNodes()
    const [{dbId, dtId, prjId, sVer}] = useProperties()

    if (! (dtId && prjId && sVer && permission.has('write'))) {
        return null
    }

    for (const node of selectedNodes) {
        if (! map.BizNode.DF.isMounted(map, node)) {
            return null
        }
    }

    const fieldRows = [...selectedNodes].map(n => n.data)

    const handleClick = async () => {
        const result = await openModal(
            <ModalDfkAdd
                dbId={dbId}
                dtId={dtId}
                prjId={prjId}
                sVer={sVer}
                fieldRows={fieldRows}
            />
        )

        if (! result) {
            return
        }

        const {data} = await map.BizNode.DT.readTree({pkid: result.fk.refDtId})

        await map.execute(() => {
            for (const node of selectedNodes) {
                const fk = map.importTree({
                    data: {
                        ...result.fk,
                        bizNodeType: 'FK',
                    },
                })

                map.appendChild(node, fk)

                const df = map.importTree({
                    data: {
                        ...result.refDfs.get(node.data.pkid),
                        bizNodeType: 'DF',
                    },
                })

                map.appendChild(fk, df)
                const dt = map.importTree({data})
                map.appendChild(df, dt)
            }
        })
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        >生成外键</Button>
    )
}
